import { useEffect, useState } from "react";
import { useSelector } from "react-redux"; // If using Redux

const DynamicTitle = () => {
    const [defaultTitle] = useState(document.title); // Store the original title
    const title = useSelector(state=>state.data.orgItem);

  useEffect(() => {
    document.title = title?.title || defaultTitle;
  }, [title?.title, defaultTitle]);

  return null; // This component doesn't render anything
};

export default DynamicTitle;
